import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/HomepageS2.css";

export default function HomepageS2() {
  const expertise = [
    {
      number: "17+",
      label: "Years of executive leadership",
    },
    {
      number: "18+",
      label: "Years of governance experience",
    },
  ];

  const safetyCapabilities = [
    {
      number: "01",
      title: "Executive Governance and Strategic Leadership",
      description:
        "Connect safety with enterprise risk, accountability, and organizational decision-making.",
    },
    {
      number: "02",
      title: "Integrated Systems and PRIME360™",
      description:
        "Apply systems thinking and a developing governance framework to connect occupational and psychological health and safety.",
    },
    {
      number: "03",
      title: "Research, Engineering and Digital Innovation",
      description:
        "Translate evidence, technology, and engineering capability into credible practical applications.",
    },
    {
      number: "04",
      title: "Global Collaboration and Knowledge Exchange",
      description:
        "Connect organizations with academic partners, practitioners, industry leaders, and international networks.",
    },
  ];

  return (
    <>
      {/* HOMEPAGE SECTION 2 */}
      <section
        id="homepage-section-two"
        className="homepage-s2"
        aria-labelledby="homepage-s2-title"
      >
        <div className="homepage-s2-background" aria-hidden="true">
          <span className="homepage-s2-orbit homepage-s2-orbit-one"></span>
          <span className="homepage-s2-orbit homepage-s2-orbit-two"></span>
          <span className="homepage-s2-glow"></span>
        </div>

        <div className="homepage-s2-container">
          {/* LEFT CONTENT */}
          <div className="homepage-s2-content">
            <p className="homepage-s2-kicker">
              Leadership and Expertise
            </p>

            <h2 id="homepage-s2-title" className="homepage-s2-title">
              Global Safety Innovation.
              <span> Executive-Level Expertise.</span>
            </h2>

            <div className="homepage-s2-text-group">
              <p className="homepage-s2-description">
                GalaxyEDGE Safety Inc. delivers high-impact occupational
                health and safety consulting, customized training, and digital
                and AI-enabled solutions—powered by global engineering and
                academic collaboration and informed by world-class leadership
                networks.
              </p>

              <p className="homepage-s2-description">
                Founded by Lisa McGuire, <strong>CRSP, ICD.D</strong>, GESI
                brings more than 17 years of executive leadership and 18 years
                of governance experience to complex workplace challenges.
              </p>

              <p className="homepage-s2-description">
                Our work connects evidence, systems thinking, technology, and
                practical implementation so organizations can move beyond
                compliance and strengthen the way safety performs across the
                enterprise.
              </p>
            </div>

            <NavLink
              to="/about-us"
              className="homepage-s2-founder-button"
            >
              <span>Meet Our Founder</span>

              <span
                className="homepage-s2-button-arrow"
                aria-hidden="true"
              >
                ↗
              </span>
            </NavLink>
          </div>

          {/* RIGHT EXPERTISE PANEL */}
          <div className="homepage-s2-visual">
            <div className="homepage-s2-expertise-card">
              <div className="homepage-s2-card-header">
                <div>
                  <p className="homepage-s2-card-label">
                    Founder and Executive Leader
                  </p>

                  <h3 className="homepage-s2-founder-name">
                    Lisa McGuire
                  </h3>
                </div>

                <div
                  className="homepage-s2-founder-monogram"
                  aria-hidden="true"
                >
                  LM
                </div>
              </div>

              <div className="homepage-s2-credentials">
                <span>CRSP</span>
                <span>ICD.D</span>
              </div>

              <div className="homepage-s2-divider"></div>

              <div className="homepage-s2-expertise-grid">
                {expertise.map((item) => (
                  <div
                    className="homepage-s2-expertise-item"
                    key={item.label}
                  >
                    <strong>{item.number}</strong>
                    <p>{item.label}</p>
                  </div>
                ))}
              </div>

              <div className="homepage-s2-focus">
                <p className="homepage-s2-focus-label">
                  Integrated expertise
                </p>

                <ul className="homepage-s2-focus-list">
                  <li>
                    <span aria-hidden="true"></span>
                    Executive leadership
                  </li>

                  <li>
                    <span aria-hidden="true"></span>
                    Safety governance
                  </li>

                  <li>
                    <span aria-hidden="true"></span>
                    Digital innovation
                  </li>

                  <li>
                    <span aria-hidden="true"></span>
                    Practical implementation
                  </li>
                </ul>
              </div>
            </div>

            {/* <div
              className="homepage-s2-floating-tag homepage-s2-tag-one"
              aria-hidden="true"
            >
              Evidence
            </div>

            <div
              className="homepage-s2-floating-tag homepage-s2-tag-two"
              aria-hidden="true"
            >
              Technology
            </div>

            <div
              className="homepage-s2-floating-tag homepage-s2-tag-three"
              aria-hidden="true"
            >
              Systems Thinking
            </div> */}
          </div>
        </div>
      </section>

      {/* HOMEPAGE SECTION 3 */}
      <section
        id="homepage-section-three"
        className="homepage-s3"
        aria-labelledby="homepage-s3-title"
      >
        <div className="homepage-s3-background" aria-hidden="true">
          <span className="homepage-s3-glow homepage-s3-glow-left"></span>
          <span className="homepage-s3-glow homepage-s3-glow-right"></span>
        </div>

        <div className="homepage-s3-container">
          <div className="homepage-s3-heading">
            <p className="homepage-s3-kicker">
              Integrated Safety Capability
            </p>

            <h2 id="homepage-s3-title" className="homepage-s3-title">
              Built for Complex
              <span> Safety Challenges</span>
            </h2>

            <p className="homepage-s3-description">
              GESI combines executive governance, occupational health and
              safety expertise, applied research, engineering collaboration,
              customized learning, digital innovation, global networks, and
              practical implementation. This integrated perspective allows
              GESI to address immediate needs while strengthening the systems,
              leadership capability, and resilience required for lasting
              performance.
            </p>
          </div>

          <div className="homepage-s3-grid">
            {safetyCapabilities.map((capability) => (
              <article
                className="homepage-s3-card"
                key={capability.number}
              >
                <div className="homepage-s3-card-top">
                  <span className="homepage-s3-card-number">
                    {capability.number}
                  </span>

                  <span
                    className="homepage-s3-card-arrow"
                    aria-hidden="true"
                  >
                    ↗
                  </span>
                </div>

                <div className="homepage-s3-card-content">
                  <h3>{capability.title}</h3>

                  <p>{capability.description}</p>
                </div>

                <div
                  className="homepage-s3-card-line"
                  aria-hidden="true"
                ></div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}